import { IObjectTranslatable, RelationalActionTranslator } from ".";
import { BeanTypes, } from "../beans/items";
import { IBarcodeItemBean } from "../beans/items/IBarcodeItemBean";
import { ITypeDefinable } from "../beans/items/ITypeDefinable";
import { IItem } from "../../../../domain/document/items/IItem";
import { BarcodeItem } from "../../../../domain/document/items/BarcodeItem";
import { BarcodeValueItem } from "../../../../domain/document/items/BarcodeValueItem";
import { Point, Rectangle, Size } from "../../../../domain/drawing";

export class BarcodeItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as IBarcodeItemBean;
    const result = new BarcodeItem();
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = true;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.name = bean.name;
    result.value = bean.text;
    result.items = bean.items.map(x => new BarcodeValueItem(x));
    result.separator = bean.barcodeSeparator;
    result.origin = bean;
    result.actions = RelationalActionTranslator.toItems(bean.relationalItems);
    return result;
  }

  toBean(item: IItem): IBarcodeItemBean {
    const target = item as BarcodeItem;
    // フロントエンド側で編集しないので基本的にそのままバックエンド側に返す。
    const bean: IBarcodeItemBean = {
      type: BeanTypes.Barcode,
      uniqueKey: target.origin.uniqueKey,
      id: target.origin.id,
      sectionObjectUid: target.origin.sectionObjectUid,
      isVisible: target.origin.isVisible,
      printVisible: target.origin.printVisible,
      previewVisible: target.origin.previewVisible,
      x: target.origin.x,
      y: Math.floor(target.geometry.rectangle.y), // 可変対応
      width: target.origin.width,
      height: target.origin.height,
      isAdditional: target.origin.isAdditional,
      isDeleted: target.origin.isDeleted,
      typeDetail: target.origin.typeDetail,
      viewTitle: target.origin.viewTitle,
      name: target.origin.name,
      text: target.origin.text,
      items: target.origin.items,
      barcodeSeparator: target.origin.barcodeSeparator,
      relationalItems: target.origin.relationalItems,
    };
    return bean;
  }
}
